/**
 * Componente de tabla semanal para Control Semanal
 */

import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { formatDate, getStateTotal, getDateTotal } from '../utils/helpers';
import { STATE_COLORS, STATE_LABELS } from '../utils/constants';

const WeeklyTable = ({
  dateColumns,
  weeklyData,
  allStates,
  onCellClick,
  onDayTotalClick,
  loading
}) => {
  if (loading) {
    return (
      <div className="text-center py-5">
        <FaIcons.FaSpinner className="fa-spin" size={40} />
        <p className="mt-3">Cargando datos semanales...</p>
      </div>
    );
  }

  if (!dateColumns.length) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <FaIcons.FaCalendarAlt size={40} className="text-muted mb-3" />
          <p className="text-muted">Cargando configuración de fechas...</p>
        </Card.Body>
      </Card>
    );
  }

  // Calcular gran total de toda la semana
  const grandTotal = allStates.reduce(
    (total, state) => total + getStateTotal(weeklyData, state),
    0
  );

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">
          <FaIcons.FaTable className="me-2" />
          Resumen Semanal por Estado
        </h5>
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table striped bordered hover className="mb-0">
            <thead className="table-primary">
              <tr>
                <th
                  className="text-center fw-bold text-white"
                  style={{ minWidth: '200px', backgroundColor: '#007bff' }}
                >
                  Estado
                </th>
                {dateColumns.map(date => (
                  <th
                    key={date}
                    className="text-center fw-bold text-white"
                    style={{ minWidth: '80px', backgroundColor: '#007bff' }}
                  >
                    {formatDate(date)}
                  </th>
                ))}
                <th
                  className="text-center fw-bold"
                  style={{
                    minWidth: '80px',
                    backgroundColor: '#28a745',
                    color: 'white'
                  }}
                >
                  Total Semana
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Filas de estados */}
              {allStates.map(stateKey => (
                <tr key={stateKey}>
                  <td className="fw-bold">
                    <Badge
                      bg={STATE_COLORS[stateKey] || 'secondary'}
                      className="me-2"
                    >
                      {STATE_LABELS[stateKey] || stateKey}
                    </Badge>
                  </td>
                  {dateColumns.map(date => {
                    const count = weeklyData[date]?.[stateKey] || 0;
                    return (
                      <td
                        key={date}
                        className={`text-center ${count > 0 ? 'clickable-cell' : ''}`}
                        onClick={() => count > 0 && onCellClick(date, stateKey)}
                        style={{
                          cursor: count > 0 ? 'pointer' : 'default',
                          backgroundColor: count > 0 ? '#f8f9fa' : 'transparent'
                        }}
                        title={
                          count > 0
                            ? `Click para ver detalles de ${formatDate(date)} - ${STATE_LABELS[stateKey] || stateKey}`
                            : ''
                        }
                      >
                        {count}
                      </td>
                    );
                  })}
                  <td
                    className="text-center fw-bold"
                    style={{ backgroundColor: '#e9ecef' }}
                  >
                    {getStateTotal(weeklyData, stateKey)}
                  </td>
                </tr>
              ))}

              {/* Fila de totales por fecha */}
              <tr className="fw-bold" style={{ backgroundColor: '#f8f9fa' }}>
                <td
                  className="text-center"
                  style={{ backgroundColor: '#6c757d', color: 'white' }}
                >
                  TOTAL POR DÍA
                </td>
                {dateColumns.map(date => {
                  const dayTotal = getDateTotal(weeklyData, date);
                  return (
                    <td
                      key={date}
                      className={`text-center ${dayTotal > 0 ? 'clickable-cell total-day-cell' : ''}`}
                      onClick={() => dayTotal > 0 && onDayTotalClick(date)}
                      style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        cursor: dayTotal > 0 ? 'pointer' : 'default',
                        transition: 'background-color 0.2s',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        if (dayTotal > 0) {
                          e.currentTarget.style.backgroundColor = '#5a6268';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#6c757d';
                      }}
                      title={
                        dayTotal > 0
                          ? `Click para ver todas las guías del ${formatDate(date)}`
                          : ''
                      }
                    >
                      {dayTotal}
                    </td>
                  );
                })}
                <td
                  className="text-center"
                  style={{ backgroundColor: '#28a745', color: 'white' }}
                >
                  {grandTotal}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default WeeklyTable;
